// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__l7PHQ","productName":"Table_productName__1V51d"};